export default __webpack_public_path__ + "static/media/team.3143a5e5.jpg";